<template>
  <div id="isInitial" v-if="isInitial">
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="content-wrapper" v-bind:class="{ modal_open: modalActive }">
      <div class="container">
        <article>
          <div class="section1">
              <img src="/lib/images/img_22.png" alt="">
          </div>
          <div class="section2">
            <div class="ttl-01 pt24">
              <img src="/lib/images/ttl_01.svg" alt="">
            </div>
            <div class="imgTxt1 pt24">
              <div class="img-01 mb8 mr40 ml40">
                <img src="/lib/images/img_03.png" alt="">
              </div>
              <div class="img-01 mb8">
                <img src="/lib/images/ttl_02.svg" alt="">
              </div>
              <p class="txt-01 w85p">規定の対象部品について、異常のある場合は<span>追加費用なし</span>で交換します。</p>
            </div>
            <div class="imgTxt1 pt24">
              <div class="img-01 mb8 mr40 ml40">
                <img src="/lib/images/img_04.jpg" alt="">
              </div>
              <div class="img-01 mb8">
                <img src="/lib/images/ttl_03.svg" alt="">
              </div>
              <p class="txt-01 w85p">見積りのために来店した経験はありませんか？コミっと車検なら<span>オンラインで見積りが可能</span>です。</p>
            </div>
            <div class="imgTxt1 pt24">
              <div class="img-01 mb8 mr40 ml40">
                <img src="/lib/images/img_05.png" alt="">
              </div>
              <div class="img-01 mb8">
                <img src="/lib/images/ttl_04.svg" alt="">
              </div>
              <p class="txt-01 w85p">税金など法定費用の支払いのために多額の現金を持ち歩く必要はありません。<span>クレジットカードでまとめて決済</span>できます。</p>
            </div>
            <div class="imgTxt1 pt24 pb28 offset2">
              <div class="img-01 mb8 mr40 ml40">
                <img src="/lib/images/img_06.png" alt="">
              </div>
              <div class="img-01 mb8">
                <img src="/lib/images/ttl_05.svg" alt="">
              </div>
              <p class="txt-01 w85p"><span>規定の対象部品は保証付き</span>(※半年間または走行距離1万kmに達した時点のいずれか短い期間)
               。さらに、次の<span>法定12ヶ月点検も無料</span>で受けられて安心です。</p>
            </div>
            <div class="info pt24 pb80" v-if="!inspectionFlag">
              <h3 class="info_ttl mb12"><img src="/lib/images/ttl_06.svg" alt=""></h3>
              <div class="info__btn mr14 ml14">
                <a v-on:click='nextPage(ssInfo, profileInfo, nativeData, versionData)'><img src="/lib/images/img_07.svg" alt=""></a>
              </div>
              <div class="info__btn info__btn1 mr14 ml14">
                <a v-on:click='nextPage(ssInfo, profileInfo, nativeData, versionData)'><img src="/lib/images/img_07.svg" alt=""></a>
              </div>
            </div>
          </div>

          <!--価格 -->
          <div class="section4 pb40">
            <div class="ttl-01 mb24 pt40">
              <img src="/lib/images/ttl_08.svg" alt="">
            </div>
            <div class="img1 mb16 mr40 ml40">
              <img src="/lib/images/img_08.svg" alt="">
            </div>
            <ul class="list pr16 pl16">
              <li class="list-item mb12 pt8 pb12 pl10 pr10">
                <div class="list-imgTxt">
                  <div class="list-imgTxt-img mb20">
                    <img src="/lib/images/img_09.svg" alt="">
                  </div>
                  <h3 class="list__ttl1">軽自動車クラス</h3>
                </div>
                <h3 class="list__ttl2"><img src="/lib/images/txt_04.svg" alt=""></h3>
              </li>
              <li class="list-item mb12 pt8 pb12 pl10 pr10">
                <div class="list-imgTxt ">
                  <div class="list-imgTxt-img mb20">
                    <img src="/lib/images/img_10.svg" alt="">
                  </div>
                  <p class="list-imgTxt-txt">車両1,000kg以下</p>
                  <h3 class="list__ttl1">小型乗用車クラス</h3>
                </div>
                <h3 class="list__ttl2"><img src="/lib/images/txt_05.svg" alt=""></h3>
              </li>
              <li class="list-item mb12 pt8 pb12 pl10 pr10">
                <div class="list-imgTxt ">
                  <div class="list-imgTxt-img mb20">
                    <img src="/lib/images/img_11.svg" alt="">
                  </div>
                  <p class="list-imgTxt-txt">車両1,500kg以下</p>
                  <h3 class="list__ttl1">中型乗用車クラス</h3>
                </div>
                <h3 class="list__ttl2"><img src="/lib/images/txt_06.svg" alt=""></h3>
              </li>
              <li class="list-item mb12 pt8 pb12 pl10 pr10">
                <div class="list-imgTxt">
                    <div class="list-imgTxt-img mb20">
                      <img src="/lib/images/img_12.svg" alt="">
                    </div>
                    <p class="list-imgTxt-txt">車両2,000kg以下</p>
                    <h3 class="list__ttl1">大型乗用車クラス</h3>
                </div>
                <h3 class="list__ttl2"><img src="/lib/images/txt_07.svg" alt=""></h3>
              </li>
            </ul>
            <p class="txt1 mr16 ml16 mb16">
              ※初年度登録から5年目、走行距離 50,000kmの場合の価格の例です<br/>
              ※エコカー減税対象車種の場合、重量税の減免を受けられる場合があります
            </p>
            <div class="img1 mr16 ml16">
              <img src="/lib/images/img_13.png" alt="">
            </div>
            <p class="txt1 mt4 mr16 ml16">
              ※「コミっと車検」を実施したお客様のアンケートから集計（集計期間：2019年8月〜2020年3月）
            </p>
          </div>

          <div class="section6">
            <div class="ttl-01 mb24 pt56">
              <img src="/lib/images/ttl_10.svg" alt="">
            </div>
            <ul class="slide pb56">
              <slick ref="slick" :options="slideshow">
                <li class="slide-item mr24">
                  <div class="slide-img">
                    <img src="/lib/images/img_18.png" alt="">
                  </div>
                  <div class="slide-info pd16">
                    <h3 class="slide-ttl mb8">アプリから3分で見積り</h3>
                    <p class="slide-txt">車検証の車種・年式と走行距離などの入力で、来店せずにその場で見積り！車検証QRの利用でさらに簡単に！</p>
                  </div>
                </li>
                <li class="slide-item mr24">
                  <div class="slide-img">
                    <img src="/lib/images/img_19.png" alt="">
                  </div>
                  <div class="slide-info pd16">
                    <h3 class="slide-ttl mb8">来店日を予約</h3>
                    <p class="slide-txt">フォームから希望日を入力！お電話で来店日を確定。スムーズな日程調整が可能です</p>
                  </div>
                </li>
                <li class="slide-item mr24">
                  <div class="slide-img">
                    <img src="/lib/images/img_20.png" alt="">
                  </div>
                  <div class="slide-info pd16">
                    <h3 class="slide-ttl mb8">車検当日</h3>
                    <p class="slide-txt">当日は店頭にお越しください。お引き渡しの際には、お車の状態や整備箇所をわかりやすくお伝えしてお返しします</p>
                  </div>
                </li>
                <li class="slide-item mr24">
                  <div class="slide-img">
                    <img src="/lib/images/img_21.png" alt="">
                  </div>
                  <div class="slide-info pd16">
                    <h3 class="slide-ttl mb8">安心のアフターサービス付</h3>
                    <p class="slide-txt">法定12ヶ月点検、車検後の半年間の整備保証など、充実・お得なアフターサービスがついています</p>
                  </div>
                </li>
              </slick>
            </ul>
          </div>

          <div class="section3 pb40 mb8">
            <div class="list-box">
              <h3 class="ttl pt40 mb24">
                <img src="/lib/images/ttl_07.svg" alt="">
              </h3>
              <ul class="list pl16 pr16">
                <li class="list-item">
                  <div class="list-icon">
                    <img src="/lib/images/icon01.png" alt="">
                  </div>
                  <h3 class="list-ttl">充実</h3>
                  <p class="list-txt1">車検でよく交換される<span>30項目以上の部品</span>を対象に、点検整備を実施</p>
                </li>
                <li class="list-item">
                  <div class="list-icon">
                    <img src="/lib/images/icon02.png" alt="">
                  </div>
                  <h3 class="list-ttl">安心</h3>
                  <p class="list-txt1">車検に必要な部品は異常箇所を全て交換。<span>エンジン・ブレーキまわりの部品は予防交換</span>を実施</p>
                </li>
                <li class="list-item">
                  <div class="list-icon">
                    <img src="/lib/images/icon03.png" alt="">
                  </div>
                  <h3 class="list-ttl">お得</h3>
                  <p class="list-txt1">見積りをアプリで行い、店頭点検の工程を効率化することで<span>お得な価格を実現</span></p>
                </li>
                <li class="list-item">
                  <div class="list-icon">
                    <img src="/lib/images/icon04.png" alt="">
                  </div>
                  <h3 class="list-ttl">アフターサービス</h3>
                  <p class="list-txt1">車検後の<span>法定12ヶ月点検を無料</span>で実施</p>
                </li>
                <li class="list-item">
                  <div class="list-icon">
                    <img src="/lib/images/icon05.png" alt="">
                  </div>
                  <h3 class="list-ttl">保証</h3>
                  <p class="list-txt1">対象部品に異常がある場合は<span>無償で交換・整備</span></p>
                  <p class="list-txt2">※半年間または走行距離1万kmに達した時点のいずれか短い期間が保証対象です</p>
                </li>
              </ul>
            </div>
            <div class="content-box mt24 ml16 mr16 mb16">
              <div class="content-box__1 mr24 ml24">
                <h3 class="content-box__ttl mb16">
                  <img src="/lib/images/icon12.svg" alt="">価格に含まれる部品・整備の例
                </h3>
                <ul class="content-box-list mb16">
                  <li class="content-box-item"><img src="/lib/images/icon06.svg" alt=""></li>
                  <li class="content-box-item"><img src="/lib/images/icon07.svg" alt=""></li>
                  <li class="content-box-item"><img src="/lib/images/icon08.svg" alt=""></li>
                </ul>
                <div class="content-box-btn">
                  <a class="pd12 modal-syncer" data-target="modal-content" v-on:click='modalOpen()'>価格に含まれる対象部品すべてを見る</a>
                </div>
              </div>
              <div class="content-box__2 mr24 ml24 mt16">
                <h3 class="content-box__ttl mb16 pt16">
                  <img src="/lib/images/icon13.svg" alt="">価格に含まれない部品・整備の例
                </h3>
                <ul class="content-box-list mb16">
                  <li class="content-box-item"><img src="/lib/images/icon09.svg" alt=""></li>
                  <li class="content-box-item"><img src="/lib/images/icon10.svg" alt=""></li>
                  <li class="content-box-item"><img src="/lib/images/icon11.svg" alt=""></li>
                </ul>
              </div>
              <p class="content-box-txt mr16 ml16 mb16">
                ※バンパー、フロントガラス、サイドミラーなど車体の破損に関わる修理費用は含まれません。
              </p>
            </div>
            <div class="info-box ml16 mr16 pt20 pr16 pl16 pb16">
              <h3 class="info-box-ttl1">
                <img src="/lib/images/icon14.svg" alt="">通常の車検との違い
              </h3>
              <h3 class="info-box-ttl2 mt8">
                来店せずに見積りできて、追加整備費用がかかりません
              </h3>
              <p class="info-box-txt1 mt8">
                通常の車検は、来店し30〜60分間点検を行った上で見積りを出しますが、実際には車検時に異常が見つかったり、部品交換を勧められたり<span>最終的に当初の見積り金額をオーバーする</span>ことがあります。
                一方でコミっと車検は、車種や年数、走行距離などから見積りを作成。車検時には規定の基準に従って部品交換・整備を行い、<sup>※</sup><span>追加費用は発生しません</span>。
              </p>
              <div class="info-box-img mb8">
                  <img src="/lib/images/img_107.svg" alt="">
              </div>
              <p class="info-box-txt2 ">
                ※規定の整備対象部品において追加の費用は発生しません。それ以外の整備、部品交換はお客様の同意の上で実施し、追加作業の扱いとして追加費用を頂く可能性がございます。（例：タイヤ交換等）
              </p>
            </div>
          </div>

          <div class="section5 mb8">
            <div class="ttl-01 mb24 pt40">
              <img src="/lib/images/ttl_09.svg" alt="">
            </div>
            <ul class="list pl16 pr16 pb40">

              <li class="list-item mb24">
                <h3 class="list-ttl pb8"><img src="/lib/images/txt_08.svg" alt=""></h3>
                <div class="list-box">
                  <div class="list-imgTxt mb12">
                    <div class="list-imgTxt-img">
                      <img src="/lib/images/img_14.png" alt="">
                    </div>
                    <div class="list-imgTxt-txt pt8 pb8 pl12 pr4 ml8 mr24">
                      過去の車検では当初の見積りより実際は高くなってしまった…
                    </div>
                  </div>
                  <div class="list-imgTxt list-imgTxt-reverse">
                    <div class="list-imgTxt-img">
                      <img src="/lib/images/img_15.png" alt="">
                    </div>
                    <div class="list-imgTxt-txt pt8 pb8 pl12 pr4 ml24 mr8">
                      コミっと車検なら、追加の整備費用もコミコミのお見積り。<br/>
                      ほとんどのお客様がお見積りから<span>追加費用なしで車検を実施</span>できています
                    </div>
                  </div>
                </div>
              </li>
              <li class="list-item mb24">
                <h3 class="list-ttl pb8"><img src="/lib/images/txt_09.svg" alt=""></h3>
                <div class="list-box">
                  <div class="list-imgTxt mb12">
                    <div class="list-imgTxt-img">
                      <img src="/lib/images/img_16.png" alt="">
                    </div>
                    <div class="list-imgTxt-txt pt8 pb8 pl12 pr4 ml8 mr24">
                      車に詳しくないのでまるっとお任せしたい
                    </div>
                  </div>
                  <div class="list-imgTxt list-imgTxt-reverse">
                    <div class="list-imgTxt-img">
                      <img src="/lib/images/img_15.png" alt="">
                    </div>
                    <div class="list-imgTxt-txt pt8 pb8 pl12 pr4 ml24 mr8">
                      コスモが定めた整備基準に沿って、<span>車検に必要な箇所を全てお任せ点検整備</span>をさせていただきます
                    </div>
                  </div>
                </div>
              </li>
              <li class="list-item">
                <h3 class="list-ttl pb8"><img src="/lib/images/txt_10.svg" alt=""></h3>
                <div class="list-box">
                  <div class="list-imgTxt mb12">
                    <div class="list-imgTxt-img">
                      <img src="/lib/images/img_17.png" alt="">
                    </div>
                    <div class="list-imgTxt-txt pt8 pb8 pl12 pr4 ml8 mr24">
                      忙しくて何度も来店する時間がとれない…
                    </div>
                  </div>
                  <div class="list-imgTxt list-imgTxt-reverse">
                    <div class="list-imgTxt-img">
                      <img src="/lib/images/img_15.png" alt="">
                    </div>
                    <div class="list-imgTxt-txt pt8 pb8 pl12 pr4 ml24 mr8">
                      ご来店いただかなくても、<span>アプリから整備費用もコミコミのお見積り</span>がご確認いただけます
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="section8">
            <div class="ttl-01 mb24 pt40">
              <img src="/lib/images/ttl_12.svg" alt="">
            </div>
            <ul class="faq pb120">
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    コミっと車検は、普通の車検とどこが違うのですか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      コミっと車検は、お見積から決済までをアプリで完了でき、オイルやバッテリーなど定額整備対象部品に異常があれば、追加整備費用なしのコミコミ価格で整備・交換する車検です。(タイヤ、タイミングベルトやバンパー、フロントガラスなど一部の部品は定額整備の対象外となります。詳しくは、アプリ上の詳細説明をご参照ください)
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    車を見ないで定めた整備項目で、安全性に問題はないのですか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      車両引受の際に整備員が点検・確認を行い、定額整備対象部品に異常があった場合は、当初ご案内していたお見積り金額に追加費用なしで全て整備・部品交換をします。また、きちんとした整備・交換基準に即して車検を実施することを徹底しています。(整備・交換基準についてはアプリ上の詳細説明をご参照ください)
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    どんな車でも車検を受けられますか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      外国車、レクサス等の一部車種はお取り扱いしておりません。その他、「コミっと車検の対象となる自動車」については、アプリ上の詳細説明、もしくは「コミっと車検利用規約」をご参照ください。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    車検証が無くても見積りはできますか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      車検証情報を手入力していただければ可能です。但し、車検証情報と走行距離情報等の必要情報を全て入力して頂かないとお見積り金額はご提示できません。また、お車をお持ち込み頂いた際に、お見積り時にご入力頂いたお車の情報と大幅に乖離がある場合は、再度、お見積りを取り直して頂くことがあります。ただし、車検実施時には車検証が必要です。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left ">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    車検証のどのQRを読み込めばいいですか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      お手元の車検証に印刷されたＱＲコードの数をご覧いただき、画面の指示に従って該当する選択肢を押下してください。<br/>
                      読取画面が起動すると読取枠の上部にガイドが表示されますので、表示されている位置のＱＲコードを読み取ってください。<br/>
                      <br/>
                      ・普通自動車で車検証がA4サイズ(210㎜×297㎜)の場合<br/>
                      「８個」を選んでください。ＱＲコード８個のうち、左から数えて２～６個目の合計５つを読み込んでください。<br/>
                      <br/>
                      ・普通自動車で車検証がA6(105㎜×177.8㎜)サイズの場合※2023年1月より交付の電子車検証<br/>
                      「５個」を選んでください。すべてのＱＲコードを読み込み、次の画面で車検満了日を入力してください。<br/>
                      <br/>
                      ・軽自動車の場合<br/>
                      「６個以下」を選んでください。すべてのＱＲコードを読み込んでください。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    追加費用が発生することはないですか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      定額整備対象部品については、アプリ上の事前見積り金額から追加費用はかかりません。定額整備対象部品外で、車検を通すための部品および、お客様のご希望によって整備・交換する部品については、追加整備として追加費用を頂きます。(定額整備対象部品についてはアプリ上の詳細説明をご参照ください)
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    代車費用は含まれていますか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      アプリ上の事前見積りには含まれておりません。代車については車検を実施する店舗にお問い合わせください。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    車検に何日間かかりますか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left ">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      車検実施に必要な日数については、車検を実施する店舗にお問い合わせください。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    どんな整備工場で整備されるのですか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      コミっと車検に加盟している指定・認証工場、もしくは提携整備工場で整備しています。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    車検を受ける店舗は自由に選べますか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      マイSSにご登録いただいた店舗が選択されます。他の店舗での車検実施をご希望の場合は、アプリのトップ画面からマイSSの登録をご変更ください。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                      <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    担当整備士の実績は？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      200時間以上の研修を受け、国家資格を取得した信頼できる整備士がしっかりと作業します。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    整備内容を説明してもらえますか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left ">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      車検前のお車の引受時、整備対象部品・箇所の状態と、必要な整備作業についてご説明させて頂きます。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    予約内容の変更/キャンセルはできますか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      予約内容、車検スケジュールの変更は、車検を実施する店舗にお問い合わせください。整備内容確定後のキャンセルは、原則お断りさせて頂いています。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    法定費用は車検当日に現金で支払うのですか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      法定費用を含む車検費用の全額が、車検終了後にアプリ経由でお支払い頂けます。店頭にて現金でも全額支払いが可能です。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    支払のタイミングはいつですか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      車検完了後、お引渡し時までにアプリからいつでもお支払い頂けます。現金でのお支払いをご希望の場合は、お引渡し時に店頭でお支払い頂けます。
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    どのような支払方法がありますか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                    <div class="faq-a__left">
                      <img src="/lib/images/txt_12.svg" alt="">
                    </div>
                    <p class="faq-a__right ml8">
                      アプリ上でのクレジットカード支払い、もしくは店頭での現金支払いのいずれかを選択して頂けます。<br/>
                      (店頭でのクレジットカードでのお支払いは、原則お断りさせて頂いています。)
                    </p>
                  </div>
                </div>
              </li>
              <li class="faq-item">
                <div class="faq-q pt8 pb8 mr16 ml16 pr24">
                  <div class="faq-q__left">
                    <img src="/lib/images/txt_11.svg" alt="">
                  </div>
                  <p class="faq-q__right ml8">
                    保証期間はありますか？
                  </p>
                </div>
                <div class="faq-a mr16 ml16">
                  <div class="faq-a__box pt8 pb24">
                  <div class="faq-a__left">
                    <img src="/lib/images/txt_12.svg" alt="">
                  </div>
                  <p class="faq-a__right ml8">
                    車検後半年または走行距離1万km以内に整備対象品目の部品で異常が発生した場合は、無料で交換整備を実施します。また、車検実施から1年後の法定12ヶ月点検を無料で実施します。
                  </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </article>
      </div>

      <div class="modal_overlay" style="background-color: rgba(0, 0, 0, 0.75);">
        <div class="modal_container">
          <div class="modal-content pt20 pr20 pl20" style="top: 16px; left: 16px;">
            <h3 class="ttl-01 mb20">
              規定の整備対象部品と整備基準
            </h3>
            <div class="modal-content__1">
              <h3 class="ttl-02 pl16 mb20">予防交換する部品</h3>
              <div class="modal-content__list">
                <dl class="pb4">
                <dt>対象部品</dt>
                <dd>整備基準</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      1
                    </div>
                    <div class="txt ml8">
                      ブレーキフルード
                    </div>
                  </dt>
                  <dd>2年以上経過</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      2
                    </div>
                    <div class="txt ml8">
                      ブレーキライニング<br/>・シュー
                    </div>
                  </dt>
                  <dd>摩擦材2mm以下</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      3
                    </div>
                    <div class="txt ml8">
                      ブレーキパッド
                    </div>
                  </dt>
                  <dd>摩擦材3mm以下</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      4
                    </div>
                    <div class="txt ml8">
                      エンジンオイル
                    </div>
                  </dt>
                  <dd>半年以上経過</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      5
                    </div>
                    <div class="txt ml8">
                      オイルエレメント
                    </div>
                  </dt>
                  <dd>オイル交換2回に1回</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      6
                    </div>
                    <div class="txt ml8">
                      バッテリー
                    </div>
                  </dt>
                  <dd>３年以上経過（ハイブリッド車の補機バッテリーは5年。保証期間が3年以上の場合は保証期間に準拠）</dd>
                </dl>
              </div>
            </div>
            <div class="modal-content__1 mt24 pb12">
              <h3 class="ttl-02 pl16 mb20">異常があれば交換する部品</h3>
              <div class="modal-content__list">
                <dl class="pb4">
                <dt>対象部品</dt>
                <dd>整備基準</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      1
                    </div>
                    <div class="txt ml8">
                      電球
                    </div>
                  </dt>
                  <dd>切れたら</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      2
                    </div>
                    <div class="txt ml8">
                      ヘッドライトコート
                    </div>
                  </dt>
                  <dd>ロービーム1灯あたり6400cd未満</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      3
                    </div>
                    <div class="txt ml8">
                      発煙筒
                    </div>
                  </dt>
                  <dd>使用期限超過時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      4
                    </div>
                    <div class="txt ml8">
                      ワイパーブレード
                    </div>
                  </dt>
                  <dd>ふき残し・ひび割れ発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      5
                    </div>
                    <div class="txt ml8">
                      ミッションオイル<br/>（ATF/CVTF）
                    </div>
                  </dt>
                  <dd>油色変化・劣化時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      6
                    </div>
                    <div class="txt ml8">
                      デフオイル
                    </div>
                  </dt>
                  <dd>油色変化・劣化時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      7
                    </div>
                    <div class="txt ml8">
                      クラッチオイル
                    </div>
                  </dt>
                  <dd>油色変化・劣化時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      8
                    </div>
                    <div class="txt ml8">
                      パワステフルード
                    </div>
                  </dt>
                  <dd>油色変化・劣化時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      9
                    </div>
                    <div class="txt ml8">
                      LLC
                    </div>
                  </dt>
                  <dd>液量低下、液色変化時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      10
                    </div>
                    <div class="txt ml8">
                      ラジエターバルブ
                    </div>
                  </dt>
                  <dd>異音、緩み、亀裂発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      11
                    </div>
                    <div class="txt ml8">
                      ラジエーター本体
                    </div>
                  </dt>
                  <dd>液漏れあり</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      12
                    </div>
                    <div class="txt ml8">
                      エアーエレメント
                    </div>
                  </dt>
                  <dd>異音、目詰まり</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      13
                    </div>
                    <div class="txt ml8">
                      スパークプラグ
                    </div>
                  </dt>
                  <dd>異常発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      14
                    </div>
                    <div class="txt ml8">
                      Vベルト
                    </div>
                  </dt>
                  <dd>異音、緩み、亀裂発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      15
                    </div>
                    <div class="txt ml8">
                      ハブベアリング
                    </div>
                  </dt>
                  <dd>異音、ガタつき発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      16
                    </div>
                    <div class="txt ml8">
                      ステアリングギアボックス
                    </div>
                  </dt>
                  <dd>液漏れあり</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      17
                    </div>
                    <div class="txt ml8">
                      ステアリングブーツ
                    </div>
                  </dt>
                  <dd>亀裂・グリス漏れ発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      18
                    </div>
                    <div class="txt ml8">
                      ドライブシャフトブーツ
                    </div>
                  </dt>
                  <dd>亀裂・グリス漏れ発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      19
                    </div>
                    <div class="txt ml8">
                      タイロットエンドブーツ
                    </div>
                  </dt>
                  <dd>亀裂・グリス漏れ発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      20
                    </div>
                    <div class="txt ml8">
                      スタビライザーリンク
                    </div>
                  </dt>
                  <dd>油滴・液漏れ発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      21
                    </div>
                    <div class="txt ml8">
                      ロアアームブーツ
                    </div>
                  </dt>
                  <dd>亀裂・グリス漏れ発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      22
                    </div>
                    <div class="txt ml8">
                      プロペラシャフト
                    </div>
                  </dt>
                  <dd>亀裂・損傷発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      23
                    </div>
                    <div class="txt ml8">
                      ショックアブソーバー
                    </div>
                  </dt>
                  <dd>油滴・液漏れあり</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      24
                    </div>
                    <div class="txt ml8">
                      ブレーキドラム
                    </div>
                  </dt>
                  <dd>亀裂・損傷発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      25
                    </div>
                    <div class="txt ml8">
                      ホイールシリンダー
                    </div>
                  </dt>
                  <dd>亀裂・損傷発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      26
                    </div>
                    <div class="txt ml8">
                      ディスクローター
                    </div>
                  </dt>
                  <dd>亀裂・損傷発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      27
                    </div>
                    <div class="txt ml8">
                      ディスクキャリパー
                    </div>
                  </dt>
                  <dd>亀裂・損傷発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      28
                    </div>
                    <div class="txt ml8">
                      ブレーキホース
                    </div>
                  </dt>
                  <dd>亀裂・損傷発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      29
                    </div>
                    <div class="txt ml8">
                      マフラーコート
                    </div>
                  </dt>
                  <dd>錆による腐食の発生時</dd>
                </dl>
                <dl class="pt12 pb12">
                  <dt class="pr12">
                    <div class="numer">
                      30
                    </div>
                    <div class="txt ml8">
                      下回り塗装
                    </div>
                  </dt>
                  <dd>錆による腐食の発生時</dd>
                </dl>
              </div>
            </div>
            <div class="info pd12">
              <h3 class="ttl mb4">※一部のエリアにおいては、下記パーツは対象外となります</h3>
              <p class="txt">
                （22）プロペラシャフト、（23）ショックアブソーバー、（26）ディスクローター、（27）ディスクキャリパー、（29）マフラーコート、（30）下回り塗装
              </p>
            </div>
            <p><a id="modal-close" class="btn-close" v-on:click="modalClose()"><img src="/lib/images/icon15.svg" alt=""></a></p>
          </div>
          <!-- /.modal_body -->
        </div>
        <!-- /.modal_container -->
      </div>

    <!-- カーケアTOPに戻るボタン -->
    <form name="fm">
      <input id="tsid" type="hidden" name="tsid" v-bind:value="tsId">
      <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="popinfoid">
      <input id="otoken" type="hidden" name="otoken" v-bind:value="otoken">
      <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="this.versionDataStore.versionData.appVersion">
      <input id="x_cls_os" type="hidden" name="platform" v-bind:value="this.versionDataStore.versionData.platform">
      <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="this.versionDataStore.versionData.osVersion">
    </form>
    </div>
</div>
<div v-else-if="isAgreement">
  <a id="isAgreement" v-on:click="toInitial()"></a>
  <Agreement></Agreement>
</div>
</template>

<script>
import Agreement from '@/views/v2/Agreement.vue'
import Loading from '@/views/v2/Loading.vue'
import Slick from 'vue-slick'
import inspection from '@/store/Api/inspection'
import modal from '@/assets/v2/modal'
import { useSsInfoStore } from '@/store/ssInfo'
import { useProfileInfoStore } from '@/store/profileInfo'
import { useNativeDataStore } from '@/store/nativeData'
import { useVersionDataStore } from '@/store/versionData'

const IS_INITIAL = 'IS_INITIAL'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  data () {
    return {
      loading: true,
      modalActive: false,
      tsId: null,
      ssInfo: null,
      profileInfo: null,
      nativeData: null,
      versionData: null,
      currentState: IS_INITIAL,
      popinfoid: null,
      otoken: null,
      slideshow: {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        arrows: false
      },
      inspectionFlag: true
    }
  },
  computed: {
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    },
    ssInfoStore: function () {
      return useSsInfoStore()
    },
    profileInfoStore: function () {
      return useProfileInfoStore()
    },
    nativeDataStore: function () {
      return useNativeDataStore()
    },
    versionDataStore: function () {
      return useVersionDataStore()
    }
  },
  methods: {
    modalOpen () {
      window.modalHeight = window.pageYOffset
      // トラッキング処理
      this.nativePVset('SHAKEN_TAISHO')
      this.nativeEVENTSet('ShakenSyosaiButton', 'MOVED_SHAKEN_TAISHO', 'TAP')
      window.scrollTo(0, 0)
      this.modalActive = true
    },
    modalClose () {
      window.scrollTo(0, window.modalHeight)
      this.modalActive = false
    },
    sameUrlScroll (number) {
      if (this.$route.hash.slice(-1) === number) {
        document.getElementById(this.$route.hash.replace(/^#/, ''))
        this.$SmoothScroll(
          document.querySelector(this.$route.hash),
          500,
          null,
          null,
          'y'
        )
      }
    },
    toInitial () {
      this.currentState = IS_INITIAL
      window.scrollTo(0, 0)
    },
    toAgreement () {
      this.currentState = IS_AGREEMENT
      this.nativeEVENTSet('ShakenSyosaiButton', 'MOVED_SHAKEN_KOKANKIJYUN', 'TAP')
      window.scrollTo(0, 0)
    },
    eventTrackStartCar () {
      this.nativeEVENTSet('ShakenSyosaiButton', 'MOVED_SHAKEN_MITSUMORI', 'TAP')
    },
    appChangeMySs () {
      // 戻るボタンの出し分け
      this.appDisplayBack(false)
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.changeMySs()
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.changeMySs.postMessage('')
      }
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    nextPage (ssInfo, profileInfo, nativeData, versionData) {
      if (this.inspectionFlag) {
        // 車検予約あり
        return
      }
      const ssInfoStore = useSsInfoStore()
      ssInfoStore.ssInfo = ssInfo
      const profileInfoStore = useProfileInfoStore()
      profileInfoStore.profileInfo = profileInfo
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = nativeData
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = versionData
      this.eventTrackStartCar()
      // 条件入力に遷移
      this.$router.push({ name: 'CarV2' })
    }
  },
  watch: {
    $route: function (n, o) {
      if (n.hash.match(/^#/)) {
        document.getElementById(n.hash.replace(/^#/, ''))
        this.$SmoothScroll(
          document.querySelector(n.hash),
          500,
          null,
          null,
          'y'
        )
      }
    }
  },
  async mounted () {
    console.log(location.href)
    $(document).ready(function () {
      $('.faq-item').on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
          $(this).children('.faq-a').stop().slideUp(300)
        } else {
          $('.faq-item').removeClass('active')
          $(this).addClass('active')
          $('.faq-a').slideUp(200)
          $(this).children('.faq-a').stop().slideDown(200)
        }
      })
      $(window).on('scroll', function () {
        // eslint-disable-next-line no-new-object
        const obj = new Object()
        obj.y = document.documentElement.scrollTop || document.body.scrollTop
        // var hBtn = $('.section2 .info').outerHeight()
        // var offSet1 = $('.info').offset().top + hBtn
        if (!$('.offset2').length) {
          return
        }
        const offSet2 = $('.offset2').offset().top + 30
        if (obj.y > offSet2) {
          $('.info__btn1').addClass('fixed')
        } else {
          $('.info__btn1').removeClass('fixed')
        }
      })
      function setEqualHeight (columns) {
        let tallestcolumn = 0
        columns.each(function () {
          const currentHeight = $(this).height()
          if (currentHeight > tallestcolumn) {
            tallestcolumn = currentHeight
          }
        })
        columns.height(tallestcolumn)
      }
      const delay = (function () {
        let timer = 0
        return function (callback, ms) {
          clearTimeout(timer)
          timer = setTimeout(callback, ms)
        }
      })()
      delay(function () {
        $('.slide-info').css('height', 'auto')
        setEqualHeight($('.slide-info'))
        $('.section3 .list-item').css('height', 'auto')
        setEqualHeight($('.section3 .list-item'))
        $('.section7 .list-item').css('height', 'auto')
        setEqualHeight($('.section7 .list-item'))
      }, 500)
      $(window).resize(function () {
        delay(function () {
          $('.slide-info').css('height', 'auto')
          setEqualHeight($('.slide-info'))
          $('.section3 .list-item').css('height', 'auto')
          setEqualHeight($('.section3 .list-item'))
          $('.section7 .list-item').css('height', 'auto')
          setEqualHeight($('.section7 .list-item'))
        }, 500)
      })
    })

    this.ssInfo = this.ssInfoStore.ssInfo
    this.profileInfo = this.profileInfoStore.profileInfo
    this.nativeData = this.nativeDataStore.nativeData
    this.versionData = this.versionDataStore.versionData
    this.tsId = this.nativeDataStore.nativeData.tsid
    this.popinfoid = this.nativeDataStore.nativeData.popinfoid
    this.otoken = this.nativeDataStore.nativeData.otoken

    let isApiError = false
    // inspection(予約)データ取得
    inspection.get(this.tsId).then(res => {
      console.log(res.data)
      if (res.data.inspections.length === 0) {
        this.inspectionFlag = false
      }
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    this.nativePVset('SHAKEN_DETAIL')
    this.loading = false
  },
  components: {
    Agreement,
    Loading,
    Slick
  }
}
</script>
